import Select from '../../../common/components/select/Select';
import {Entity} from '../../../modules/auth/authorization/api';
import React from 'react';

interface SelectEntityProps {
    name?: string;
    value?: Entity;
    setFieldValue: any;
    touched?: boolean;
    error?: string;
    entities?: Entity[];
}

const SelectEntity = ({name, value, setFieldValue, entities}: SelectEntityProps): JSX.Element => {
    return (
        <Select<Entity>
            label={'Entité'}
            isClearable={true}
            isSearchable={true}
            name={name}
            onChange={(entity) => {
                setFieldValue(entity);
            }}
            value={value}
            getOptionValue={(entity) => entity.id.toString()}
            getOptionLabel={(entity) => entity.name}
            options={entities}
            placeholder={'Veuillez sélectionner une entité'}
        />
    );
};

export default SelectEntity;
